// extracted by mini-css-extract-plugin
module.exports = {"root":"UEHcbn","selectRange":"TpXfwE"};